"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _excluded = ["type", "label", "size", "color", "outline", "icon", "iconPosition", "className", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The Tag component is used in association with another UI element to provide categorization informations.
 */
var Tag = function Tag(_ref) {
  var type = _ref.type,
      label = _ref.label,
      size = _ref.size,
      color = _ref.color,
      outline = _ref.outline,
      icon = _ref.icon,
      iconPosition = _ref.iconPosition,
      className = _ref.className,
      children = _ref.children,
      attributes = _objectWithoutPropertiesLoose(_ref, _excluded);

  var classes = (0, _clsx.default)('uk-tag', "uk-tag--" + type, outline && 'outline', color !== 'default' && color, size !== 'default' && size, iconPosition !== 'left' && 'reverse', icon && !label && !children && 'icon-only', className);
  return /*#__PURE__*/_react.default.createElement("span", _extends({
    className: classes
  }, attributes), icon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: icon
  }), (label || children) && /*#__PURE__*/_react.default.createElement("span", null, label || children));
};

Tag.propTypes = {
  /**
   * Predefined styling of the Tag
   */
  type: _propTypes.default.oneOf(['specs', 'tagline', 'box', 'overlay']),

  /**
   * Label of the Tag
   */
  label: _propTypes.default.string,

  /**
   * Size of the Tag
   */
  size: _propTypes.default.oneOf(['tiny', 'small', 'default', 'large', 'xlarge']),

  /**
   * Background-color of the Tag (or border-color if outline)
   */
  color: _propTypes.default.oneOfType([_propTypes.default.oneOf(['default', 'primary', 'secondary', 'success', 'alert', 'warning', 'black', 'white', 'custom']), _propTypes.default.string]),

  /**
   * Invert styling colors of the Tag
   */
  outline: _propTypes.default.bool,

  /**
   * Add an Icon in the Tag
   */
  icon: _propTypes.default.string,

  /**
   * Alignment of the Icon within the Tag
   */
  iconPosition: _propTypes.default.oneOf(['left', 'right'])
};
Tag.defaultProps = {
  type: 'box',
  size: 'default',
  color: 'default',
  outline: false,
  iconPosition: 'left'
};
var _default = Tag;
exports.default = _default;